// Lib
import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import Button from '../Button';
import OrderList from './OrderList';
import TotalQtyLabel from '../../components/Labels/TotalQtyLabel';

// Hooks
import useUser from '../../hooks/useUser';

// Styles
import { useStyles } from './OrderHistoryStyles';

const OrderHistory = ({ orders, isRecurring = false }) => {
  const { isKiteUser } = useUser();
  const { classes } = useStyles({
    isKiteUser,
  });
  const search = useSelector((state) => state.search);
  const { general: generalOrders, recurring: recurringOrders } = useSelector(
    (state) => state.orders,
  );
  const navigate = useNavigate();

  const navigateToMaterials = useCallback(
    () => navigate('/materials'),
    [navigate],
  );

  if (
    (isRecurring ? recurringOrders : generalOrders)?.length === 0 &&
    !search
  ) {
    return (
      <div className={classes.emptyOrdersContainer}>
        <Typography
          className={classes.emptyOrdersHistory}
          variant="h1"
          textAlign="center">
          {isRecurring
            ? 'There are currently no recurring orders saved in your order history'
            : 'There are currently no orders saved in your order history'}
        </Typography>
        <Button
          onClick={navigateToMaterials}
          className={classes.emptyOrdersHistoryButton}>
          Go To Materials
        </Button>
      </div>
    );
  }

  return (
    <>
      <TotalQtyLabel
        qty={orders?.length}
        type={'order'}
        className={classes.totalLabel}
      />
      <OrderList
        orders={orders}
        isRecurring={isRecurring}
        isKiteUser={isKiteUser}
      />
    </>
  );
};

export default OrderHistory;
